import React from "react";
import { Card, Col, Row, Typography, Divider, Flex, Space } from "antd";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import { useSelector } from "react-redux";
import moment from "moment";

const { Title, Text } = Typography;

const PayrollSummary: React.FC = () => {
    const parasm = useSelector(({ app }) => app?.params)
    const calendarDays = moment(parasm?.selectedMonth, 'MMM YYYY').daysInMonth()
    let current_month = moment(parasm?.selectedMonth).format('MM-YYYY')
    const payRollData = useSelector(({ app }) => app?.cache[`payroll-${current_month}`]?.data);
    let past_month = moment(payRollData?.lastMonthData?.month, 'MM-YYYY').format('MMM')

    const range = `${parasm?.selectedMonth} (${parasm?.selectedDuration}, ${calendarDays})`

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <HeadingSubHeading titleProps={{ level: 5 }} title={range} />
            <Card className="main-card-box">
                <Row gutter={16} className="main-card-row">
                    <Col span={5}>
                        <Card style={{ backgroundColor: "#EAE7FD", borderRadius: "8px" }}>
                            <Flex justify="space-between">
                                <div>
                                    <Text type="secondary">TOTAL EMPLOYEES</Text>
                                    <Title level={5} style={{ margin: 0, lineHeight: 1.5 }}>
                                        {payRollData?.totalEmployee} <Text style={{ color: "#F5222D" }}>↓ {payRollData?.totalEmployee - payRollData?.totalPayrollProcessed}</Text>{" "}
                                        <Text style={{ color: "#52C41A" }}>↑ {payRollData?.totalPayrollProcessed}</Text>
                                    </Title>
                                </div>
                                <div>
                                    <Text type="secondary">CALENDAR DAYS</Text>
                                    <Title level={5} style={{ margin: 0, lineHeight: 1.5 }}>{calendarDays}</Title>
                                </div>
                            </Flex>
                            <Divider style={{ margin: '6px 0px' }} />
                            <div>
                                <Text type="secondary">PAYROLL PROCESSED</Text>
                                <Title level={5} style={{ margin: 0, lineHeight: 1.5 }}>{payRollData?.totalPayrollProcessed}/{payRollData?.totalEmployee}</Title>
                            </div>
                        </Card>
                    </Col>
                    <Col span={19}>
                        <Row gutter={16}>
                            <Col span={5}>
                                <Card>
                                    <Text type="secondary">TOTAL PAYROLL COST</Text>
                                    <Title level={5} >INR {payRollData?.totalPayrollCost}</Title>
                                    <Text type="secondary">{past_month} INR {payRollData?.lastMonthData?.totalPayrollCost} ↓</Text>
                                </Card>
                            </Col>
                            <Col span={1} className="align-center-item">
                                <Text strong>=</Text>
                            </Col>
                            <Col span={5}>
                                <Card>
                                    <Text type="secondary">EMPLOYEE DEPOSIT</Text>
                                    <Title level={5}>INR {payRollData?.employeeDeposit}</Title>
                                    <Text type="secondary">{past_month} INR {payRollData?.lastMonthData?.employeeDeposit} ↓</Text>
                                </Card>
                            </Col>
                            <Col span={1} className="align-center-item">
                                <Text strong>+</Text>
                            </Col>
                            <Col span={5}>
                                <Card>
                                    <Text type="secondary">TOTAL DEDUCTIONS</Text>
                                    <Title level={5}>INR {payRollData?.totalDeduction}</Title>
                                    <Text type="secondary">{past_month} INR {payRollData?.lastMonthData?.totalDeduction} ↓</Text>
                                </Card>
                            </Col>
                            <Col span={1} className="align-center-item">
                                <Text strong>+</Text>
                            </Col>
                            <Col span={6}>
                                <Card>
                                    <Text type="secondary">TOTAL CONTRIBUTIONS</Text>
                                    <Title level={5}>INR {payRollData?.totalContribution}</Title>
                                    <Text type="secondary">{past_month} INR {payRollData?.lastMonthData?.totalContribution} ↓</Text>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </Space>
    );
};

export default PayrollSummary;
